module.exports = __webpack_public_path__ + "img/containerFrontRightOutline.2ec8547d.svg";